import { IStyleConfig, mergeStyles, plural } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';
import { NBSP } from '../../constants';
import { VILLAGES_COUNT_LABELS } from '../../interfaces/village';

interface IVillagesCount {
  label: string;
  count: number;
  link: string;
  onLinkClick(label: string): void;
  styleCont?: IStyleConfig;
}
export class VillagesCount extends React.Component<IVillagesCount> {
  public render() {
    const { label, count, link, styleCont } = this.props;

    return (
      <p {...mergeStyles(styleCont, styles['grey_text'], styles['villages_count'])}>
        {VILLAGES_COUNT_LABELS[label]}
        {NBSP}
        <a
          href={link}
          className={styles['villages_link']}
          onClick={() => this.props.onLinkClick(label)}
          target="_blank"
        >
          {`${count} ${plural(count, ['посёлок', 'посёлка', 'посёлков'])}`}
        </a>
      </p>
    );
  }
}
